<template>
  <deep-main
    v-if="token"
    auth="token"
    :environment.prop="deepPayEnvironment"
    :features.prop="featuresConfig"
    :locale="currentLocale"
    :secret="token"
    v-bind="$attrs"
  ></deep-main>
</template>

<script lang="ts">
interface PaymentPerAccount {
  debitIBAN: string
  ownNameAddress: NameAddress
  payments: Payments
  totalAmount: string // string because amount is "0.05"
  numberOfPayments: number
}

interface NameAddress {
  companyName: string
}

interface Payments {
  payment: Payment[]
}

interface Payment {
  executionDate: string // ISO date string (e.g. "2023-08-30")
  currency: string // e.g. "CHF"
  amount: string // string to preserve precision
  destinationAccount: DestinationAccount
  otherNameAddress: NameAddress
}

interface DestinationAccount {
  iban: IbanDetails
}

interface IbanDetails {
  iban: string
  paymentPurpose: string
}

export interface PaymentData {
  paymentFile: string
  targetNodeId: string
  paymentPerAccount: PaymentPerAccount[]
}
</script>
<script lang="ts" setup>
import { isLocalOrDevEnv } from '@/utils/helpers/env.ts'
import { useKeycloak } from '@/composables/auth/keycloak'

const { locale } = useI18n()
const { token } = useKeycloak()

onMounted(async () => {
  await import('@deeppay/deep-pay-client')
})

const deepPayEnvironment = computed(() => {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case 'int':
      return 'INT'
    case 'demo':
      return 'DEV'
    case 'prod':
      return 'PROD'
    default:
      return 'DEV'
  }
})

const featuresConfig = computed(() => {
  return {
    showBankId: isLocalOrDevEnv(),
  }
})

const currentLocale = computed(() => locale.value)
</script>

<style lang="scss">
deep-main {
  --deeppay-color-success: rgb(var(--v-theme-deeppay));
}
</style>
